module.exports = __webpack_public_path__ + "static/media/button.1fa52924.glb";